import plainText from './plainText.js';

// The Branded layout (owner, 2026-11-02): the same letter as Plain text
// (greeting, body, signature, files, events), sent inside the email kit's
// card with the logo and the footer from Settings. The email is built on the
// server (functions/eshot-dispatch.js brandedEmailHtml). The composer edits
// it with the same letter editor as Plain text; the preview shows the frame.
export default {
  id: 'branded',
  name: 'Branded',
  description: 'Your logo at the top, the message in a white card, the company footer at the bottom. Files and events show as teal buttons and cards.',
  slots: plainText.slots,
};
